module.exports = __webpack_public_path__ + "assets/img/1ae5-kr.svg";